import {
  GET_IDENTIFIERS_CHECK,
  convertParams,
  convertResult,
} from 'app/common/api/requests/cabinet/identifiers/check/get'
import { IdentifiersApproveInfo, Params } from 'app/common/types/identifiers/approve'

import { CommonDataOptions, useCommonDataProvider } from 'app/dataProviders/useCommonDataProvider'

const defaultState: IdentifiersApproveInfo = {
  balance: 0,
  price: 0,
}

type Options = CommonDataOptions<IdentifiersApproveInfo, Params>

export function useIdentifierApprove(options: Options = {} as Options) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_IDENTIFIERS_CHECK,
    convertions: {
      convertParams,
      convertResult,
    },
    defaultState,
  })

  return res
}
